import { img as betongkakelkeramik } from '@/store/tempimages/betongkakelkeramik'
import { img as hardplast } from '@/store/tempimages/hardplast'
import { img as energiatervinning } from '@/store/tempimages/energiatervinning'
import { img as metall } from '@/store/tempimages/metall'
import { img as tradgardsavfall } from '@/store/tempimages/tradgardsavfall'
import { img as wellpapp } from '@/store/tempimages/wellpapp'
import { img as gips } from '@/store/tempimages/gips'
import { img as risochgrenar } from '@/store/tempimages/risochgrenar'
import { img as lastpallar } from '@/store/tempimages/lastpallar'
import { img as dack } from '@/store/tempimages/dack'
import { img as bocker } from '@/store/tempimages/bocker'
import { img as elavfall } from '@/store/tempimages/elavfall'
import { img as farligtavfall } from '@/store/tempimages/farligtavfall'
import { img as geogtabyggmaterial } from '@/store/tempimages/geogtabyggmaterial'
import { img as tra } from '@/store/tempimages/tra'
import { img as kolfrys } from '@/store/tempimages/kolfrys'
import { img as batterier } from '@/store/tempimages/batterier'
import { img as klader } from '@/store/tempimages/klader'
import { img as rest } from '@/store/tempimages/rest'
import { img as forpack } from '@/store/tempimages/forpack'
import { img as inpasseringutpassering } from '@/store/tempimages/inpasseringutpassering'
import { img as sorteringsguide } from '@/store/tempimages/sorteringsguide'

import { getGreenCoursePages } from '@/api/Courses/GetGreenCoursePages'
import { getGreenCourseSettings } from '@/api/Courses/GetGreenCourseSettings'
import { getGreenCourseSettingPages } from '@/api/Courses/GetGreenCourseSettingPages'
import { getGreenCourseSystemSettings } from '@/api/GetGreenCourseSystemSettings'

export default {
  state: {
    settings: {
      primaryColor: '#FFFFFF',
      secondaryColor: '#FFFFFF',
      pageTitle: '',
      courseLogo: '',
    },
    pages1: null,
    pages2: null,
    pages3: null,
    pages4: null,
    systemSettings: null,
  },
  getters: {
    
    getPageGroup1: (state) => (state.pages1 ? state.pages1 : null),
    getPageGroup2: (state) => (state.pages2 ? state.pages2 : null),
    getPageGroup3: (state) => (state.pages3 ? state.pages3 : null),
    getPageGroup4: (state) => (state.pages3 ? state.pages4 : null),
    getSettings: (state) => (state.settings ? state.settings : null),
    getSystemSettings: (state) => (state.systemSettings ? state.systemSettings : null),
  },
  mutations: {
    setPageGroup1(state, payload) {
      state.pages1 = payload
    },
    setPageGroup2(state, payload) {
      state.pages2 = payload
    },
    setPageGroup3(state, payload) {
      state.pages3 = payload
    },
    setPageGroup4(state, payload) {
      state.pages4 = payload
    },
    unsetSettingPages(state) {
      state.pages1 = null
      state.pages2 = null
    },
    unsetCoursePages(state) {
      state.pages3 = null
      state.pages4 = null
    },
    unsetPageGroup1(state) {
      state.pages1 = null
    },
    unsetPageGroup2(state) {
      state.pages2 = null
    },
    unsetPageGroup3(state) {
      state.pages3 = null
    },
    unsetPageGroup4(state) {
      state.pages4 = null
    },
    setSettings(state, payload) {
      state.settings = payload
    },
    setSystemSettings(state, payload) {
      state.systemSettings = payload
    }
  },
  actions: {
    async fetchSettingPages({ commit }) {
      await getGreenCourseSettingPages().then(result => {
        const mapGroup = (group) => {
          return group.pages.map(page => ({
            prio: page.priority,
            title: page.title,
            content: page.content,
            nextButtonText: page.nextButtonText
          }))
        };
  
        const group1 = mapGroup(result.data.groups.find(group => group.pageGroup === 1));
        const group2 = mapGroup(result.data.groups.find(group => group.pageGroup === 2));
        commit('setPageGroup1', group1)
        commit('setPageGroup2', group2)

        return true
      }).catch(err => {
        
        return false
      })
    },
    async fetchSettings({ commit }) {
      await getGreenCourseSettings().then(result => {
        const settings = result.data;
        commit('setSettings', settings)

        return true
      })
    },
    async fetchSystemSettings({ commit }) {
      await getGreenCourseSystemSettings().then(result => {
        commit('setSystemSettings', result.data)
        return true
      }).catch(err => {
        return false
      })
    },
    async fetchPages({ commit }, { courseId }) {
      commit('unsetCoursePages')
      await getGreenCoursePages(courseId).then(result => {
        const mapGroup = (group) => {
          return group.pages.map(page => ({
            prio: page.priority,
            title: page.title,
            content: page.content,
            nextButtonText: page.nextButtonText
          }))
        };
  
        const groups = result.data.groups;
        const group3 = mapGroup(groups.find(group => group.pageGroup === 3));
        const group4 = mapGroup(groups.find(group => group.pageGroup === 4));
     
        commit('setPageGroup3', group3)
        commit('setPageGroup4', group4)

        return true
      }).catch(err => {
        
        return false
      })
    }
  }
}